// import Vuex from 'vuex'
// const store = new Vuex.Store({
//     modules:{
//         login:require('../s/login').default}
//     })
import axios from 'axios'
import store from '../s/index.js'
var routes = require('./default.js').default
const yet_router = (user_routes, guest_access=false)=>{
    if(!guest_access){
        routes[1].meta={roles: ['admin'],login:true}
    }
    // console.log(routes)
    return {
        routes: routes,
        beforeEach: async (to, from, next)=>{
            //Login Check
            for(let ro of to.matched){
                Object.assign(to.meta,ro.meta)
            }
            // console.log("META",to.meta)
            // console.log("URoute",user_routes)
            // console.log('EVERY ?',user_routes.every)
            if(user_routes.every){
                for(let func of user_routes.every){
                    func.action();
                }
            }
            if(user_routes.restrictions){
                user_routes.restrictions.roles.push({role: 'admin',redirect: '/adminlogin'})
            
            let toRolePath=()=>{
                if(!to.meta.login){
                    next();
                    return false
                }
                if(to.meta.roles){
                    // let role_found = false;
                    for(let expRole of to.meta.roles){
                        for(let _role of user_routes.restrictions.roles){
                            if(_role.role == expRole){
                                // role_found = true
                                next(_role.redirect)
                                return true;
                            }
                        }
                    }
                }
                //Redirect to Default Login
                next(user_routes.restrictions.loginPath || '/')
            }
            let user = store.state.login.user;
            if(!user){
                console.log('CHECKING LOGIN REMOTELY')
                let res_login = await axios.get(`/api/is_login?${Math.random()}`)
                if(res_login.data.login){
                    if(user_routes.restrictions.beforeLogin){
                        for(let func of user_routes.restrictions.beforeLogin){
                            await func.action();
                        }
                    }
                    store.commit('login',res_login.data.user)
                    if(user_routes.restrictions.postLogin){
                        for(let func of user_routes.restrictions.postLogin){
                            console.log('POST-LOGIN', func)
                            await func.action();
                        }
                    }
                    user = store.state.login.user
                }
                else{
                    store.commit('login',null)
                    if(to.meta.login){
                        if(!toRolePath()){
                            return;
                        }
                    }
                    else{
                        next()
                    }
                    return
                }    
            }
            // console.log("Further checks",to.meta,user.role)
            // console.log(to.meta)
            if(to.meta.roles){
                //Role Check Required
                for(let role of user.role){
                    // console.log("ROLE CHECKING",role,to.meta.roles)
                    if(to.meta.roles.find(r=>r == role.name)){
                        // console.log('ROLE CHECK',to.meta.roles,role.name)
                        //Found Match role
                        // console.log('USER ROUTES',user_routes)
                        if(user_routes.restrictions.userBasedChecks && to.meta.checks){
                            for(let check of user_routes.restrictions.userBasedChecks){
                                // console.log('CHECK / ROLE / TO.META.CHECKS',check,role,to.meta.checks)
                                if(check.role==role.name && to.meta.checks.indexOf(check.name) >= 0){
                                    // console.log("CHECK FOUND")
                                    if(!(await check.yes())){
                                        next(check.redirect)
                                        return;
                                    }
                                }
                            }
                        }
                        next()
                        return;
                    }
                }
                // To Login Path
                if(!toRolePath()){
                    return;
                }
            }
            else{
                //Guest Accessable
                if(user_routes.restrictions.userBasedChecks && to.meta.checks){
                    for(let check of user_routes.restrictions.userBasedChecks){
                        if(to.meta.checks.indexOf(check.name) >= 0){
                            if(!(await check.yes())){
                                next(check.redirect)
                                return;
                            }
                        }
                    }
                }
                next()
            } 
        }
        else{
            next()
        }
        }
    }
}
export default yet_router;